import PropTypes from "prop-types";
import React, { Fragment, useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  getDiscountPrice,
  getProductCartQuantity,
} from "../../helpers/product";
// import Rating from "./sub-components/ProductRating";
import ProductModal from "./ProductModal";
import { connect, useDispatch } from "react-redux";
import { isProductTobaccoEligible, getPriceRelatedToCustomer, refModal, formatCurrency } from "../../pages/constant/utils";
import { useHistory } from "react-router-dom";
import { fetchProductBySlug } from "../../redux/actions/productActions";
import { Select, Tooltip, notification } from "antd";
import { DropdownInput } from "./DropdownInput";
import { defaultImageUrl, UNIT, defaultLogo, saleBadgeFour } from "../../pages/constant/Constants";
import { Col, Divider, Row } from 'antd';
import Upcoming from "./../../assets/images/Upcoming.png";
import { DropdownInputGrid } from "./DropdownInputGrid";
import { license } from "../../pages/other/Profile/my-account/utils";
import Promotions from "../common/Promotions";
import PromotionsPrice from "../common/PromotionPrice";
import PromotionsQTY from "../common/PromotionQTY";

const ProductGridListSingle = ({
  product,
  currency,
  addToCart,
  addToWishlist,
  addToCompare,
  cartItem,
  wishlistItem,
  compareItem,
  cartitems,
  settingData,
  themeSettingData,
  userData,
  cartItems,
  userDetail,
  sidebarFilter,
  setScrollToTop
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const { addToast } = useToasts();
  const [quantityCount, setQuantityCount] = useState("00");
  const licensePath = () => history.push('/profile/my-account')
  const discountedPrice = getDiscountPrice(product.price, product.discount);
  let modalRef = useRef(null);
  const [selectedProductColor] = useState(
    product.variation ? product.variation[0].color : ""
  );
  const [selectedProductSize] = useState(
    product.variation ? product.variation[0].size[0].name : ""
  );
  const productCartQty = getProductCartQuantity(
    cartitems,
    product,
    selectedProductColor,
    selectedProductSize
  );

  const finalProductPrice = +(
    getPriceRelatedToCustomer(userData, product) * currency.currencyRate
  ).toFixed(2);
  const finalDiscountedPrice = +(
    discountedPrice * currency.currencyRate
  ).toFixed(2);
  // console.log("product?.variant_product_images",product?.variant_product_images)
  const handleProductClick = () => {
    dispatch(
      fetchProductBySlug(
        product,
        () => history.push(`/product/${product.slug}`),
        () => history.push('/shop')
      )
    );
  };
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (
      !product.back_order_ecom &&
      (["", 0, null].includes(quantityCount) ||
        productCartQty + Number(quantityCount) > product.saleable_qty)
    ) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [quantityCount, productCartQty, product]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 445);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 445);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Fragment>
      {/* new Card start */}
      <Col className="gutter-row" xl={sidebarFilter == "inActive" ? 8 : 12} lg={sidebarFilter == "inActive" ? 12 : 12} md={12} sm={24} style={{ padding: "0px", marginBottom: isMobile ? "2%" : "" }} >
        <div className={sidebarFilter === "inActive" ? "card-old" : "card-old-inactive"} style={{ display: "flex" }}>
          <div className={sidebarFilter === "inActive" ? "card-old-side-inactive" : ""}>
            <Link
              to={`/product/${product.slug}`}>
              <div
                style={{
                  // borderRadius: "8px",
                  backgroundImage: `url(${product?.default_image === defaultImageUrl
                    ? (themeSettingData?.logo === defaultLogo ? Upcoming : process.env.PUBLIC_URL + themeSettingData?.logo)
                    : process.env.PUBLIC_URL + (product?.default_image || product?.images_seo[0]?.url)
                    })`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: product?.default_image === defaultImageUrl ? '100%' : 'contain',
                  display: "flex",
                  backgroundColor: product?.default_image === defaultImageUrl || product?.images_seo[0] === defaultImageUrl ? "#f7f7f7" : "",
                  alignItems: "end",
                  ...(product?.default_image === defaultImageUrl || product?.images_seo[0] === defaultImageUrl ? {
                    backgroundPosition: 'center',
                  } : {})
                }}


                className={sidebarFilter === "inActive" ? "old-img-inactive" : "old-img"}
              >
                <Promotions product={product} classMain={"promotion"}
                  classText={product?.selected_unit_price?.promotion?.sale_badge_template === saleBadgeFour ? "promotion-text-four" : "promotion-text"} />
              </div>
            </Link>
          </div>
          <div
            style={{ padding: sidebarFilter == "inActive" ? "2px 1px 0px 12px" : "2px 0px 0px 12px", width: "100%", overflow: "hidden" }}
            className={sidebarFilter == "inActive" ? "card-old-side" : "card-old-side-inactive"}
          >
            {/* Category and in stock info */}
            <div style={{ display: "flex", flexFlow: "wrap" }}>
              <div
                className="category-tag"
              >
                <span
                  style={{
                    fontSize: `${sidebarFilter == "inActive" ? "12px" : "12px"}`,
                  }}
                  className="card-old-brach-name"
                >
                  {window.innerWidth <= 430 && product?.category_name.length > 10
                    ? `${product?.category_name.slice(0, 8)}...`
                    : product?.category_name.slice(0, 8)}...`
                </span>
              </div>

              {(product?.product_variant_attribute.length == 0) && ((!userDetail?.user && themeSettingData?.stock_display_for_unsecure_user) ||
                (userDetail?.user && themeSettingData?.stock_display_for_secure_user)) && (
                  <div
                    className="frame-5"
                    style={{
                      background: product?.back_order_ecom
                        ? "#FDFAEB"
                        : product.saleable_qty <= 0
                          ? "transparent"
                          : "#EFEDF8",
                    }}
                  >
                    <div
                      className="text-wrapper-4"
                      style={{
                        color: product?.back_order_ecom
                          ? "#EFD138"
                          : product?.saleable_qty <= 0
                            ? "#FB1100"
                            : "#5F4BB6",
                      }}
                    >
                      {product?.back_order_ecom
                        ? "Low Stock"
                        : product?.saleable_qty <= 0
                          ? ""
                          : `Qty: ${product.saleable_qty || 0}`}
                    </div>
                  </div>
                )}
            </div>
            {/* Product Name */}
            <div
              className="card-old-name"
              onClick={handleProductClick}
            >
              <p
                className="product-name-old-card"
              >
                {product?.group_name || product?.ecom_name || product?.name}
              </p>
            </div>

            {/* product price */}
            {((!userDetail?.user && themeSettingData?.price_display_for_unsecure_user) ||
              (userDetail?.user && themeSettingData?.price_display_for_secure_user)) && (
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <PromotionsPrice product={product} currency={currency.currency_symbol} regularprice={true} sidebarFilter={sidebarFilter} />
                  </div>
                  {product?.vg_id == null && (
                    <div className="mobile-unit">
                      Unit: Piece
                    </div>
                  )}
                  {product?.is_tax_inclusive &&
                    <p className="tax-inclusive">Tax Inclusive</p>
                  }
                </div>

              )}
            {/* unit and quantity section */}

            {product?.vg_id == null && (
              <div
                className={sidebarFilter === "inActive" ? !product?.back_order_ecom && product?.saleable_qty <= 0 ?
                  "card-old-qty-and-unit-inactive-out_of_stock" : "card-old-qty-and-unit-inactive" :
                  !product?.back_order_ecom && product?.saleable_qty <= 0 ? "card-old-qty-and-unit-out-of-stock " : "card-old-qty-and-unit"}

              >
                <div className="shop-page-card-unit">
                  <div className="shop-page-unit">
                    <Select
                      disabled
                      value={product.selected_unit_price.unit}
                      className="unit-select"
                      style={{ width: "auto" }}
                    >
                      {Object.keys(UNIT).map((unit) => (
                        <Select.Option value={UNIT[unit].value}>
                          {UNIT[unit].name}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                  <div className="text-wrapper-3-sku">
                    <Tooltip title={
                      themeSettingData?.sku_display_on_product_card && product?.sku && themeSettingData?.upc_display_on_product_card && product?.upc
                        ? `${product.sku} / ${product.upc}`
                        : themeSettingData?.sku_display_on_product_card && product?.sku
                          ? product.sku
                          : themeSettingData?.upc_display_on_product_card && product?.upc
                            ? product.upc
                            : ''
                    }>
                      <span>
                        {themeSettingData?.sku_display_on_product_card && product?.sku && themeSettingData?.upc_display_on_product_card && product?.upc
                          ? isMobile
                            ? `${product.sku}/${product.upc}` // Show full SKU/UPC on mobile
                            : `${product.sku}/${product.upc}`.length > 9
                              ? `${product.sku}/${product.upc}`.substring(0, 9) + '...'
                              : `${product.sku} / ${product.upc}`
                          : themeSettingData?.sku_display_on_product_card && product?.sku
                            ? product.sku
                            : themeSettingData?.upc_display_on_product_card && product?.upc
                              ? product.upc
                              : ''
                        }
                      </span>
                    </Tooltip>
                  </div>
                </div>

                <div
                  className="shop-page-card-add-to-cart"
                  style={{ marginTop: !product?.back_order_ecom && product?.saleable_qty <= 0 ? "auto" : "" }}

                >

                  <label
                    style={{
                      color: "#1A1A1A",
                      textAlign: "center",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "14px",
                    }}
                    className="qty-label"
                  >
                    <PromotionsQTY selectedVariant={product} />
                  </label>
                  {product?.back_order_ecom || !product?.saleable_qty <= 0 ? (
                    <DropdownInputGrid
                      className="increment-inactive"
                      sidebarFilter={sidebarFilter}
                      decrement={() =>
                        setQuantityCount(
                          Number(quantityCount) > 1
                            ? Number(quantityCount) - 1
                            : 0
                        )
                      }
                      increment={() => {
                        if (
                          isProductTobaccoEligible(product, userData, settingData)
                        ) {
                          setQuantityCount(
                            !product.back_order_ecom
                              ? Number(quantityCount) < product.saleable_qty
                                ? Number(quantityCount) + 1
                                : Number(quantityCount)
                              : Number(quantityCount) + 1
                          );
                        } else {
                          refModal(modalRef, licensePath)
                        }
                      }}
                      value={quantityCount}
                      handleChange={({ target: { value } }) => {
                        const formattedValue = value.replace(/\D/g, "");
                        if (
                          !product.back_order_ecom &&
                          Number(formattedValue) > product.saleable_qty
                        ) {
                          notification.error({
                            message:
                              "You can not add more than in stock quantity",
                          });
                          return;
                        }
                        setQuantityCount(formattedValue);
                      }}
                    />
                  ) : null}
                  <div
                    // style={{
                    //   display: "flex",
                    //   justifyContent: "flex-end",
                    //   width: "100%",
                    // }}
                    className="add-to-button"
                  >
                    <button
                      type="button"
                      disabled={
                        !product?.back_order_ecom && product?.saleable_qty <= 0
                      }
                      className={
                        sidebarFilter === "inActive"
                          ? (!product?.back_order_ecom && product?.saleable_qty <= 0 ? "out-of-stock-shop btn-add-to-card" : "add-to-cart-button btn-add-to-card")
                          : (!product?.back_order_ecom && product?.saleable_qty <= 0 ? "out-of-stock-shop btn-add-to-cart-button-inactive" : "add-to-cart-button-inactive")
                      } onClick={() => {
                        setScrollToTop(false);
                        if (!userDetail?.user) {
                          addToast("Please login first to add in the cart", {
                            appearance: "info",
                            autoDismissTimeout: 1000,
                            autoDismiss: true,
                          });
                        } else
                          if (isDisabled) {
                            notification.error({
                              message: "You can not add more than in stock quantity",
                            });
                            return;
                          }
                        if (product?.eligibility_check && !product?.eligibility_check?.is_eligible) {
                          notification.error({ message: `Sale of this ${product?.name} is not allowed due to ${product?.eligibility_check?.reasons}. Please upload the license in the 'Profile' section to make a purchase.` })
                        }
                        else {
                          if (
                            isProductTobaccoEligible(product, userData, settingData)
                          ) {
                            addToCart(
                              product,
                              addToast,
                              cartItems,
                              Number(quantityCount),
                              settingData.channel_id,
                            );

                          } else {
                            refModal(modalRef)
                          }
                        }

                      }}
                    >
                      {!product?.back_order_ecom && product?.saleable_qty <= 0
                        ? "Out of Stock" : "Add to Cart"}
                    </button>
                  </div>
                </div>
              </div>
            )}
            {product?.variant_product_images[1] && (
              <div style={{ display: "flex" }}>
                {product?.variant_product_images
                  .filter((image) => image.images[0] !== defaultImageUrl)
                  .slice(0, 6)
                  .map((image, index) => (
                    <div key={index} style={{ display: "flex" }}>
                      <div
                        className={sidebarFilter === "inActive" ? "shop-variant-card-inactive" : "shop-variant-card"}
                        style={{ display: "flex", flexDirection: "row" }}>
                        <Row
                          className={sidebarFilter === "inActive" ? "variant-image-inactive" : "variant-image"}
                          style={{ margin: "3px 10px 0px 3px", height: "45px", overflow: "hidden", position: "relative", flexWrap: "nowrap" }}
                        >
                          {image?.images[0] !== defaultImageUrl && (
                            <div
                              className="thumbnail-2"
                              onClick={handleProductClick}
                              style={{
                                // margin: "5px",
                                // height: "45px", 
                                display: `${!image?.images ? "none" : ""}`
                              }}
                            >
                              <img src={
                                image?.images === defaultImageUrl
                                  ? (themeSettingData?.logo === defaultLogo ? Upcoming : process.env.PUBLIC_URL + themeSettingData?.logo)
                                  : process.env.PUBLIC_URL + image?.images[0]
                              } alt="Image" />
                            </div>
                          )}
                        </Row>
                      </div>
                    </div>
                  ))}
              </div>
            )}
            {product?.vg_id ?
              <div style={{ display: "flex", justifyContent: "end", alignItems: "end" }}>
                <button
                  className={sidebarFilter == "inActive" ? "variant-btn-horizontal-inactive" : "variant-btn-horizontal"}
                  onClick={handleProductClick}>View Variants</button>
              </div>
              : null}


          </div>
        </div>
      </Col>

      {/* product modal */}
      <ProductModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        product={product}
        currency={currency}
        discountedprice={discountedPrice}
        finalproductprice={finalProductPrice}
        finaldiscountedprice={finalDiscountedPrice}
        cartitem={cartItem}
        wishlistitem={wishlistItem}
        compareitem={compareItem}
        addtocart={addToCart}
        cartItems={cartItems}
        addtowishlist={addToWishlist}
        addtocompare={addToCompare}
        addtoast={addToast}
      />
    </Fragment>
  );
};

ProductGridListSingle.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  cartItem: PropTypes.object,
  cartitems: PropTypes.array,
  compareItem: PropTypes.object,
  userData: PropTypes.object,
  currency: PropTypes.object,
  product: PropTypes.object,
  cartItems: PropTypes.array,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  wishlistItem: PropTypes.object,
  settingData: PropTypes.object,
  userDetail: PropTypes.object,
};


const mapStateToProps = (state) => {
  return {
    cartitems: state.cartData,
    settingData: state.settingData.ecom.basic,
    themeSettingData: state.settingData.ecom.theme,
    userData: state.userData.user,
    cartItems: state.cartData,
    userDetail: state.userData,
    currency: state.settingData?.["admin-panel"]?.basic || {},
  };
};

export default connect(mapStateToProps)(ProductGridListSingle);
